import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Collapse,
  Row,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { useResponsive } from "../../utils/use-responsive";
import {
  PlusOutlined,
  QuestionCircleFilled,
  UpOutlined,
} from "@ant-design/icons";
import styles from "./approved-card.module.scss";

const { Panel } = Collapse;
const { Title, Text } = Typography;

export const CustomerFinanceCard: React.FC<{
  title: string;
  tooltip: string;
  icon: string;
  details: any;
  optional?: boolean;
}> = ({ title, tooltip, icon, details = false, optional = false }) => {
  const { isXs } = useResponsive();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  function showOptionalOrIcon() {
    if (!isXs && !optional) {
      return (
        <div className={styles["cardIcon"]}>
          <img alt="Icon" src={icon} />
        </div>
      );
    } else if (!isXs && optional) {
      return (
        <Row justify="space-between">
          <img alt="Icon" src={icon} />
          <Text type="secondary">Optional</Text>
        </Row>
      );
    }
  }

  return (
    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
      <Card style={{ borderRadius: "8px" }}>
        <Space direction={"vertical"} size={"middle"} className={"full-width"}>
          {showOptionalOrIcon()}

          <Space.Compact direction={"vertical"} className={"full-width"}>
            <Space
              direction={"horizontal"}
              size={"small"}
              className={"ant-row-space-between"}
            >
              <Space direction={"horizontal"} size={"small"}>
                <Text type="secondary" style={{ margin: 0 }}>
                  Current amount due
                </Text>
              </Space>
              {isXs && !optional && <img alt="Icon" src={icon} />}
            </Space>
            <Title level={2} style={{ margin: 0, fontWeight: "lighter" }}>
              {details["currentAmountDue"]}
            </Title>
          </Space.Compact>

          <Row typeof="flex" justify="space-between" className={"full-width"}>
            <Col typeof="flex" className={!isXs ? "" : "full-width"}>
              <Space.Compact direction={"vertical"} className={"full-width"}>
                <Space
                  direction={"horizontal"}
                  size={"small"}
                  className={"ant-row-space-between"}
                >
                  <Space direction={"horizontal"} size={"small"}>
                    <Text type="secondary" style={{ margin: 0 }}>
                      Next payment date
                    </Text>
                  </Space>
                </Space>
                <Title level={3} style={{ margin: 0, fontWeight: "lighter" }}>
                  {details["nextPaymentDate"]}
                </Title>
              </Space.Compact>
            </Col>
            <Col typeof="flex">
              <Space direction={"vertical"} style={{ rowGap: "0px" }}>
                <Text type="secondary" style={{ margin: 0 }}>
                  Next payment amount
                </Text>
                <Title level={3} style={{ fontWeight: 300, marginTop: 0 }}>
                  {details["nextPaymentAmount"]}
                </Title>
              </Space>
            </Col>
          </Row>

          <Space.Compact direction={"vertical"} className={"full-width"}>
            <Space
              direction={"horizontal"}
              size={"small"}
              className={"ant-row-space-between"}
            >
              <Space direction={"horizontal"} size={"small"}>
                <Text type="secondary" style={{ margin: 0 }}>
                  Monthly service fee
                </Text>
              </Space>
            </Space>
            <Title level={3} style={{ margin: 0, fontWeight: "lighter" }}>
              {details["monthlyServiceFee"]}
            </Title>
          </Space.Compact>
        </Space>
      </Card>
    </Col>
  );
};
